<!--{
  "resourceType": "ActivityDefinition",
  "id": "cbc-test",
  "status": "active",
  "kind": "ServiceRequest",
  "code": {
    "coding": [{
      "system": "http://loinc.org",
      "code": "57021-8",
      "display": "Complete blood count"
    }]
  },
  "description": "Order a complete blood count test",
  "subjectCodeableConcept": {
    "coding": [{ "code": "Patient" }]
  },
  "priority": "routine",
  "timingTiming": {
    "repeat": {
      "frequency": 1,
      "period": 1,
      "periodUnit": "d"
    }
  },
  "location": {
    "reference": "Location/lab"
  }
}
-->

<mat-card>
    <mat-card-header style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding-right: 16px; box-sizing: border-box;">
        <div>
            <mat-card-title>Service Details</mat-card-title>
            <mat-card-subtitle class="subtitle-text-color-2 small-subtitle">
                Use the stepper to capture service details.
            </mat-card-subtitle>
        </div>
        <button mat-stroked-button color="primary" (click)="printTemplate()" [disabled]="!step1Form.get(['code'])?.value" style="margin-bottom: 8px;">
            <mat-icon>print</mat-icon> Print Template
        </button>
    </mat-card-header>

    <mat-card-content>
        <mat-stepper linear [orientation]="(stepperOrientation$ | async) ?? 'horizontal'">
            <mat-step [stepControl]="step1Form" label="Service">
                <div class="guide g-just-flex  mb-16" style="justify-content: space-between;">
                    <div class="title-subtitle g-just-flex flex-column mb-8 " style="align-items: flex-start;">
                        <div class="title">
                            Service Name
                        </div>
                        <div class="subtitle-text-color-2 small-subtitle">
                            Name your service by selecting from existing service codes or creating a new one
                        </div>

                    </div>
                    <!-- button to add new service request code -->
                    <div class="g-just-flex flex-end ">
                        <button mat-flat-button color="accent" (click)="openNewServiceRequestCodeDialog()">
                            <mat-icon>add</mat-icon>
                            Add New Service Code
                        </button>
                    </div>
                </div>

                <form [formGroup]="step1Form" class="py-12">

                    <!-- {{serviceCodeAndCategory | json}} -->
                    @if(!serviceCodeAndCategory || editServiceCodeAndCategoryMode){
                    <!-- {{jugglingEffect | json}} -->
                    <app-service-request-code-picker [typeOfService]="jugglingEffect"
                        (selectionChange)="onServicePickerChange($event)">
                    </app-service-request-code-picker>

                    }
                    <!-- @if(step1Form.get(['code'])?.value){
                    {{step1Form?.value | json}}
                    } -->

                    @if(step1Form.valid && step1Form.get(['code'])?.value.code){
                    <mat-card>
                        <mat-card-header class="spaced-title">
                            <mat-card-title style="font-size:1.2rem">
                                <div class="g-just-flex" style="align-items: center; justify-content: space-between;">
                                    <span class="real-title">Chosen Name & Standardized Code For Service</span>
                                    @if(serviceCodeAndCategory || editServiceCodeAndCategoryMode){
                                    <button mat-button><mat-icon class="small-mat-icon"
                                            (click)="showServiceRequestCodePicker()">edit</mat-icon></button>
                                    }
                                </div>
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content class="py-12">
                            <div class="g-just-flex list" style="justify-content: space-between;">
                                <div class="label">
                                    Name
                                </div>

                                <div class="g-just-flex" style="justify-content: flex-end;">
                                    {{(step1Form.get(['code'])?.value)?.display}}
                                </div>

                            </div>
                            <div class="g-just-flex list" style="justify-content: space-between;">
                                <div class="label">
                                    Standard Code
                                </div>

                                <div class="g-just-flex" style="justify-content: flex-end;">
                                    {{(step1Form.get(['code'])?.value)?.code}}
                                </div>

                            </div>
                            <div class="g-just-flex list" style="justify-content: space-between;">
                                <div class="label">
                                    Category
                                </div>

                                <div class="g-just-flex" style="justify-content: flex-end;">
                                    {{(step1Form.get(['category'])?.value)?.display}} -
                                    {{(step1Form.get(['category'])?.value)?.code}}
                                </div>

                            </div>
                        </mat-card-content>
                    </mat-card>
                    }

                    <div class="g-just-flex flex-between mt-16">
                        <span></span>
                        <button mat-raised-button color="primary" matStepperNext [disabled]="step1Form.invalid">
                            Next
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                    </div>
                </form>
            </mat-step>

            <mat-step label="Details" [completed]="isItemsArrayTruthSourceValid()">
                <div class="guide g-just-flex  mb-16" style="justify-content: space-between;">
                    <div class="title-subtitle g-just-flex flex-column mb-8" style="align-items: flex-start;">
                        <div class="title">
                            Items Required for Service
                        </div>
                        <div class="subtitle-text-color-2 small-subtitle">
                            Choose reagent & materials required for this service.
                            Choose from materials that have been registered in the system
                            or register a new material available a your location
                        </div>

                    </div>
                    <!-- button to add new service request code -->
                    <div class="g-just-flex flex-end mb-8">
                        <button mat-flat-button color="accent" (click)="addNewSupplyDelivery()">
                            <mat-icon>add</mat-icon>
                            Add New Material
                        </button>
                    </div>
                </div>
                @if(!itemsArrayTruthSource || itemsArrayTruthSource.length === 0){

                @if(itemsRequiredForm){

                <app-dynamic-forms-v2 [formFields]="itemsRequiredForm!"
                    (formSubmitted)="processValuesFromDynamicForm($event)"
                    [formMetaData]="formMetaDataForItemsRequired">


                </app-dynamic-forms-v2>
                }@else {
                ...loading
                }
                }
                @if(itemsArrayTruthSource && itemsArrayTruthSource.length > 0){
                <!-- {{itemsArrayTruthSource | json}} -->
                @if(itemsRequiredForm){
                <app-resource-data-review [submittedData]="{itemsRequired: itemsArrayTruthSource}"
                    [resource]="{itemsRequired: itemsArrayTruthSource}" [formFields]="itemsRequiredForm"
                    [showEditButtons]="true" (resourceUpdated)="onEditItemsRequired($event)">

                </app-resource-data-review>
                } @else {
                ...loading
                }
                }

                <div class="g-just-flex flex-between mt-16">
                    <button mat-button matStepperPrevious type="button">
                        <mat-icon>chevron_left</mat-icon>
                        Previous
                    </button>
                    <button mat-raised-button color="primary" matStepperNext type="button"
                        [disabled]="!isItemsArrayTruthSourceValid()">
                        Next
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </mat-step>

            <mat-step label="Observations (Optional)">
                <div class="guide g-just-flex  mb-16" style="justify-content: space-between;">
                    <div class="title-subtitle g-just-flex flex-column mb-8" style="align-items: flex-start;">
                        <div class="title">
                            Required Observation Codes
                        </div>
                        <div class="subtitle-text-color-2 small-subtitle">
                            Optional: preconfigure which observation(s) (lab test names/codes) should be filled when
                            performing this service.
                            If left empty, the system will fall back to using the ServiceRequest code as the placeholder
                            observation.
                        </div>

                    </div>
                </div>

                @if(!requiredObservationsArrayTruthSource || requiredObservationsArrayTruthSource.length === 0){
                @if(requiredObservationsForm){
                <app-dynamic-forms-v2 [formFields]="requiredObservationsForm!"
                    (formSubmitted)="processValuesFromRequiredObservationsForm($event)"
                    [formMetaData]="{ formName: '', formDescription: '', submitText: 'Save' }">


                </app-dynamic-forms-v2>
                }@else {
                ...loading
                }
                }

                @if(requiredObservationsArrayTruthSource && requiredObservationsArrayTruthSource.length > 0){
                @if(requiredObservationsForm){
                <app-resource-data-review [submittedData]="{requiredObservations: requiredObservationsArrayTruthSource}"
                    [resource]="{requiredObservations: requiredObservationsArrayTruthSource}"
                    [formFields]="requiredObservationsForm" [showEditButtons]="true"
                    (resourceUpdated)="onEditRequiredObservations($event)">

                </app-resource-data-review>
                } @else {
                ...loading
                }
                }

                <div class="g-just-flex flex-between mt-16">
                    <button mat-button matStepperPrevious type="button">
                        <mat-icon>chevron_left</mat-icon>
                        Previous
                    </button>
                    <button mat-raised-button color="primary" matStepperNext type="button">
                        Next
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </mat-step>

            <mat-step [stepControl]="step3Form" label="Price"
                [completed]="existingChargeItemDefinition || newChargeItemDefinition">
                <div class="guide g-just-flex  mb-16" style="justify-content: space-between;">
                    <div class="title-subtitle g-just-flex flex-column mb-8" style="align-items: flex-start;">
                        <div class="title">
                            Service Pricing Details
                        </div>
                        <div class="subtitle-text-color-2 small-subtitle">
                            Define the pricing details for this service by creating a new charge item definition
                            or editing an existing one.
                        </div>

                    </div>
                    <!-- button to add new service request code -->
                    <!-- <div class="g-just-flex flex-end mb-8">
                        <button mat-flat-button color="accent" (click)="openNewServiceRequestCodeDialog()">
                            <mat-icon>add</mat-icon>
                            Add New Service Code
                        </button>
                    </div> -->
                </div>
                @if(!newChargeItemDefinition && !existingChargeItemDefinition){
                <app-dynamic-forms-v2 [formFields]="priceFields" (formSubmitted)="onFormSubmit($event)"
                    [formMetaData]="formMetaDataForPrice">
                </app-dynamic-forms-v2>

                }@else {
                <!-- {{newChargeItemDefinition | json}} -->
                <app-resource-data-review
                    [resource]="convertChargeItemDefinitionToFormData((existingChargeItemDefinition || newChargeItemDefinition)!)"
                    [submittedData]="convertChargeItemDefinitionToFormData((existingChargeItemDefinition || newChargeItemDefinition)!)"
                    [formFields]="priceFields" [showEditButtons]="true" (resourceUpdated)="onFormSubmit($event)">

                </app-resource-data-review>

                }

                <div class="g-just-flex flex-between mt-16">
                    <button mat-button matStepperPrevious type="button">
                        <mat-icon>chevron_left</mat-icon>
                        Previous
                    </button>
                    <span></span>
                    <button mat-raised-button color="primary" (click)="saveServiceDetails()" type="button"
                        [disabled]="!newChargeItemDefinition && !existingChargeItemDefinition">
                        Save Service Details
                        <mat-icon>check</mat-icon>
                    </button>
                </div>

            </mat-step>
        </mat-stepper>
    </mat-card-content>
</mat-card>